import Modal from '../../../components/common/Modal'
import Button from '../../../components/common/Button'

interface DeleteConfirmProps {
  isOpen: boolean
  memberName: string
  onConfirm: () => void
  onCancel: () => void
}

function DeleteConfirm({
  isOpen,
  memberName,
  onConfirm,
  onCancel,
}: DeleteConfirmProps) {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onCancel}
      title="Confirmer la suppression"
      footer={
        <div className="modal-actions">
          <Button variant="outline" onClick={onCancel}>
            Annuler
          </Button>
          <Button variant="primary" onClick={onConfirm}>
            Supprimer
          </Button>
        </div>
      }
    >
      <div className="delete-confirm-content">
        <p>
          Êtes-vous sûr de vouloir supprimer le membre <strong>{memberName}</strong> ?
        </p>
        <p className="warning-text">Cette action est irréversible.</p>
      </div>
    </Modal>
  )
}

export default DeleteConfirm
